<template>
  <base-modal-bottom
    ref="modal"
    class="modal-pix-key-invalid has-text-centered"
    :isFooter="true"
    :title="title"
    :withClickOverlay="false"
    :btnClose="false"
  >
    <div class="margin-bottom">
      <base-icon width="90" height="115" name="erro-transfer-pix" />
    </div>

    <div class="margin-bottom title-message">
      <p>
        <strong>{{ message }}</strong>
      </p>
    </div>

    <p class="subtitle-message">
      A chave PIX informada não pertence a um dos titulares do site ({{
        nameOne
      }}
      e {{ nameTwo }}) ou não existe. Cadastre uma nova chave PIX para realizar
      suas transferências.
    </p>
    <template #footer>
      <base-button-bottom
        @click.native="close"
        class="is-primary is-big"
        type="button"
      >
        Ok, entendi!
      </base-button-bottom>
    </template>
  </base-modal-bottom>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseModalBottom from '@/components/BaseModalBottom.vue'
import BaseButtonBottom from '@/components/BaseButtonBottom.vue'

export default {
  components: {
    BaseModalBottom,
    BaseButtonBottom,
  },

  props: {
    title: {
      type: String,
      default: 'Validacão de segurança',
    },
    message: {
      type: String,
      default: 'Não foi possível validar a chave PIX informada',
    },
  },

  computed: {
    ...mapGetters({
      wedSiteInfo: 'app/getWedSiteInfo',
    }),

    nameOne() {
      return this.wedSiteInfo ? this.wedSiteInfo.noivo1_nome.split(' ')[0] : ''
    },
    nameTwo() {
      return this.wedSiteInfo ? this.wedSiteInfo.noivo2_nome.split(' ')[0] : ''
    },
  },

  methods: {
    open() {
      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()
      this.$emit('onClose')
    },
  },
}
</script>

<style lang="scss">
.modal-pix-key-invalid {
  .title-message,
  .subtitle-message,
  strong {
    max-width: 429px;
    margin: 0 auto;
    font-size: 16px;
    color: $neutral;
  }
}
</style>
